import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/yeppy/delivery_back.png";

const Deliveryyeppy = () => {
  return (
    <div
      className="delivery_yeppy"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-7 offset-lg-7 my-auto"
          >
            <h4>Delivery Phase</h4>
            <p>
              The Deliver phase represents the culmination of our design
              process, where we prepare our solutions for implementation. Our
              deliverables for this phase encompass various aspects essential
              for the successful development and launch of Yeppy.
            </p>
            <ul>
              <li>UI/UX Designs</li>
              <p>
                Our design team has created high-fidelity UI/UX designs that
                capture the app's final look and feel. These designs prioritize
                user-friendliness, smooth navigation, and a consistent visual
                identity, aiming to offer an engaging and aesthetically pleasing
                user experience.
              </p>
              <li>Technical Specifications</li>
              <p>
                We understand the importance of precise technical specifications
                for executing our design concepts. These specifications detail
                the technology stack, system architecture, data flow, and
                integration points, providing the development team with a clear
                blueprint for app construction
              </p>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Deliveryyeppy;
